/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCallDto
 */
export interface UpdateCallDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCallDto
     */
    comment: string;
}

/**
 * Check if a given object implements the UpdateCallDto interface.
 */
export function instanceOfUpdateCallDto(value: object): value is UpdateCallDto {
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function UpdateCallDtoFromJSON(json: any): UpdateCallDto {
    return UpdateCallDtoFromJSONTyped(json, false);
}

export function UpdateCallDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCallDto {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'],
    };
}

export function UpdateCallDtoToJSON(json: any): UpdateCallDto {
    return UpdateCallDtoToJSONTyped(json, false);
}

export function UpdateCallDtoToJSONTyped(value?: UpdateCallDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

